import { useEffect } from "react";
import { useAuth } from "../contexts/AuthContext";
import { Spinner, makeStyles, shorthands } from "@fluentui/react-components";
import LoggingService from "../services/loggingService";
import { MessageType } from "../enums/messageType";

const useStyles = makeStyles({
  container: {
    "> div": { ...shorthands.padding("200px") },
  },
});

export default function PopupLoginCallback() {
  const auth = useAuth();
  const styles = useStyles();
  
  LoggingService.log(LoggingService.isLoggingEnabled() ? `PopupLoginCallback - Popup Sign-in callback event triggered.` : '', MessageType.Info);

  useEffect(() => {
    auth.popupLoginCallback().then(() => {
      LoggingService.log(LoggingService.isLoggingEnabled() ? `PopupLoginCallback - Popup Sign-in callback event successful.` : '', MessageType.Info);
    }).catch(function(err) {
      LoggingService.log(LoggingService.isLoggingEnabled() ? `PopupLoginCallback - Popup Sign-in callback event failed - ${err}` : '', MessageType.Error);
    });
  }, []);

  return (
    <div className={styles.container}> 
      <Spinner size="large" labelPosition="below" label="Processing popup sign-in callback..." /> 
    </div>
  );
}
